<div class="container margin">

  <form [formGroup]="userForm" (ngSubmit)="userForm.valid?saveUser(userForm.value):errorMessage()"
    enctype="multipart/form-data" autocomplete="off">

    <div style='display: flex; width: 100%; '>
      <div style='flex:10'>
        <mat-tab-group>

          <mat-tab label="Básica ">

            <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">

              <div class='first-row'>

                <div class='row-item'>
                  <mat-form-field>
                    <mat-label>Nombre completo</mat-label>
                    <input autocomplete="off" type="text" formControlName='name' matInput #nombre maxlength="255"
                      placeholder="Nombre completo" required>
                    <mat-hint>{{nombre.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <mat-form-field>
                    <mat-label>Usuario</mat-label>
                    <input [readonly]='tipoRedireccion == "actualizar"' #user1 autocomplete="new-pasord" type="text" matInput required placeholder="Usuario"
                      formControlName='user' (blur)="userChanged(user1.value)">
                    <mat-hint>{{user1.value.length}}/50</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item-button'>

                  <div style='width:100%;'>
                    <!-- cargo -->
                    <combos [control]="userForm.get('jobTitleId')" [configuration]='combosConfigPosition'
                      [reloadCombo]='reloadComboPosition' [required]="true" [filter]="true">
                    </combos>
                  </div>
                  @if (tipoRedireccion!="actualizar") {
                    <div style='min-width: 24px; max-width: 24px; cursor:pointer;'>
                      <div (click)='addNew("cargo")' matRipple>
                        <mat-icon>add_circle</mat-icon>
                      </div>
                    </div>
                  }

                </div>


              </div>

              <div class='default-row'>

                <div class='row-item'>
                  <mat-form-field [appOpenDatepickerOnClick]="dateJoining">

                    <mat-label>Fecha ingreso</mat-label>
                    <input matInput [matDatepicker]="dateJoining" autocomplete="off" matInput
                      formControlName='dateJoining' required>
                    <mat-datepicker-toggle matIconSuffix [for]="dateJoining">
                    </mat-datepicker-toggle>
                    <mat-datepicker #dateJoining [touchUi]='movil?true:false'></mat-datepicker>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>



                <div class='row-item'>
                  <mat-form-field>
                    <mat-label>Contraseña</mat-label>
                    <input [readonly]='tipoRedireccion=="actualizar" || validateIfUserExists.userExists'
                      autocomplete="off" [type]="hide ? 'password' : 'text'" matInput #contrasenia maxlength="255"
                      placeholder="Contraseña" formControlName='password' required>
                    @if (tipoRedireccion!='actualizar') {
                      <div class="hide-button" mat-icon-button matIconSuffix
                        (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                      </div>
                    }
                    <mat-hint>{{contrasenia.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <!-- roles -->
                  <combos [control]="userForm.get('roleId')" [configuration]='combosConfigRole'
                    [reloadCombo]="reloadComboRole" [required]="true">
                  </combos>
                </div>

              </div>

              <div class='default-row'>

                <div class='row-item-button'>

                  <div style='width:100%;'>
                    <!-- Areas -->
                    <combos [control]="userForm.get('areaId')" [configuration]='combosConfigArea'
                      [reloadCombo]='reloadComboArea' [required]="true" [filter]="true">
                    </combos>

                  </div>
                  @if (tipoRedireccion!="actualizar") {
                    <div style='min-width: 24px; max-width: 24px; cursor:pointer;'>
                      <div (click)='addNew("area")' matRipple>
                        <mat-icon>add_circle</mat-icon>
                      </div>
                    </div>
                  }

                </div>


                <div class='row-item-button'>

                  <div style='width:100%;'>
                    <!-- Eps -->
                    <combos [control]="userForm.get('epsId')" [configuration]='combosConfigEps'
                      [reloadCombo]='reloadComboEps' [required]="true" [filter]="true">
                    </combos>
                  </div>

                  <!-- <div *ngIf='tipoRedireccion!="actualizar"' style='min-width: 24px; max-width: 24px; cursor:pointer;'>
                  <div (click)='addNew("eps")' matRipple>
                    <mat-icon>add_circle</mat-icon>
                  </div>
                </div> -->

              </div>

              <div class='row-item-button'>

                <div style='width:100%;'>
                  <!-- Arl -->
                  <combos [control]="userForm.get('arlId')" [configuration]='combosConfigArl'
                    [reloadCombo]='reloadComboArl' [required]="true" [filter]="true">
                  </combos>
                </div>

                <!-- <div *ngIf='tipoRedireccion!="actualizar"' style='min-width: 24px; max-width: 24px; cursor:pointer;'>
                <div (click)='addNew("arl")' matRipple>
                  <mat-icon>add_circle</mat-icon>
                </div>
              </div> -->

            </div>

          </div>



        </cdk-virtual-scroll-viewport>

      </mat-tab>

      <mat-tab label=" Adicional">
        <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport">

          <div class='first-row'>

            <div class='row-item' style='width:100%;'>
              <!-- pais -->
              <combos [configuration]='combosConfigCountry' [reloadCombo]='reloadComboCountry' [required]="false"
                (changeOption)='changesCountry($event)'>
              </combos>
            </div>


            <div class='row-item'>
              <!-- Despartamento -->
              <combos [configuration]='combosConfigRegion' [reloadCombo]='reloadComboRegion' [required]="false"
                [filter]="true" (changeOption)='changesRegion($event)'>
              </combos>

            </div>


            <div class='row-item'>
              <!-- ciudades -->
              <combos [control]="userForm.get('cityId')" [configuration]='combosConfigCity' [reloadCombo]='reloadComboCity' [required]="false"
                [filter]="true">
              </combos>
            </div>

          </div>

          <div class='default-row'>

            <div class='row-item'>
              <mat-form-field>
                <mat-label>Dirección</mat-label>
                <input autocomplete="off" type="text" formControlName='address' matInput #direccion maxlength="255"
                  placeholder="Direccion">
                <mat-hint>{{direccion.value.length}}/255</mat-hint>
              </mat-form-field>
            </div>

            <div class='row-item'>
              <mat-form-field>
                <mat-label>Teléfono</mat-label>
                <input autocomplete="off" type="number" matInput formControlName='phone' #telefono
                  oninput="this.value = this.value.slice(0,20)" placeholder="Telefono">
                <mat-hint>{{telefono.value.length}}/20</mat-hint>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>

            <div class='row-item'>
              <mat-form-field>
                <mat-label>Correo</mat-label>
                <input autocomplete="off" type="text" matInput formControlName='email' #correo maxlength="255"
                  placeholder="Correo" (blur)="emailChanged(correo.value)">
                <mat-hint>{{correo.value.length}}/255</mat-hint>
                @if (userForm.get('email')?.hasError('email')) {
                  <mat-error>
                    Ingrese un correo válido
                  </mat-error>
                }
                @if (userForm.get('email')?.hasError('emailExists')) {
                  <mat-error>
                    Este correo electrónico ya está registrado
                  </mat-error>
                }
              </mat-form-field>
            </div>

          </div>


          <div class='default-row'>

            <div class='row-item'>
              <file-input style="width: 100%;" [params]='fileInput'
              (fileSave)='fileChange($event, "photo")'></file-input>
            </div>

            <div class='row-item'>
              <file-input style="width: 100%;" [params]='fileInputCv'
              (fileSave)='fileChange($event, "cv")'></file-input>
            </div>

          </div>

        </cdk-virtual-scroll-viewport>

      </mat-tab>


    </mat-tab-group>
  </div>

  <div style='flex:.2'>
    <button mat-mini-fab color="warn" type="submit">
      <mat-icon>save</mat-icon>
    </button>

    @if (tipoRedireccion=="actualizar") {
      <button mat-mini-fab color="accent" (click)='deleteUser($event)'
        style='margin-top: 10px;'>
        <mat-icon>delete</mat-icon>
      </button>
    }


    <button mat-mini-fab color="primary" (click)='back($event)' style='margin-top: 10px;'>
      <mat-icon>reply</mat-icon>
    </button>

    @if (tipoRedireccion=="actualizar") {
      <button mat-mini-fab (click)='openCV()' color='primary'
        style='margin-top: 10px;' matTooltip='Abrir hoja de vida'>
        <mat-icon>assignment_ind</mat-icon>
      </button>
    }


  </div>
</div>
</form>

</div>
